"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9582],{

/***/ 71125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ BreadcrumbItemLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);



const BreadcrumbItemLink = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: "breadcrumbs__item-link",
        ...props,
        children: children
    });
};
BreadcrumbItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const BreadcrumbItem = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "breadcrumbs__item",
        ...props
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);


/***/ }),

/***/ 78086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Breadcrumbs_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Breadcrumbs.js




const Breadcrumbs = (param)=>{
    let { className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("breadcrumbs", className),
        children: children
    });
};
Breadcrumbs.propTypes = {
    className: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js



/***/ }),

/***/ 43360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const GuidePageTemplateMain = (param)=>{
    let { sidebar =true , children , ...props } = param;
    const responsiveProps = sidebar ? {
        auto: true
    } : {
        lg: 9
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        ...responsiveProps,
        ...props,
        children: children
    });
};
GuidePageTemplateMain.propTypes = {
    sidebar: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (GuidePageTemplateMain);


/***/ }),

/***/ 69738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ GuidePageTemplateNavItemLink; },
/* harmony export */   "hS": function() { return /* binding */ GuidePageTemplateNavItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);




const GuidePageTemplateNavItem = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "guide-page-template__nav-item",
        children: children
    });
};
GuidePageTemplateNavItem.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
const GuidePageTemplateNavItemLink = (param)=>{
    let { href , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: href,
        className: "guide-page-template__nav-item-link",
        ...props,
        children: children
    });
};
GuidePageTemplateNavItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const GuidePageTemplateNav = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "guide-page-template__nav",
        children: children
    });
};
GuidePageTemplateNav.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["ZP"] = (GuidePageTemplateNav);


/***/ }),

/***/ 51921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const GuidePageTemplateSidebar = (param)=>{
    let { md =4 , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: md,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "guide-page-template__sidebar",
            children: children
        })
    });
};
GuidePageTemplateSidebar.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired,
    md: prop_types__WEBPACK_IMPORTED_MODULE_3__.number
};
/* harmony default export */ __webpack_exports__["Z"] = (GuidePageTemplateSidebar);


/***/ }),

/***/ 41635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ GuidePageTemplate_GuidePageTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/GuidePageTemplate.js






const GuidePageTemplate = (param)=>{
    let { type ="guide" , wrapperClassName ="" , sidebar =true , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("guide-page-template", "guide-page-template-type-".concat(type), wrapperClassName),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                center: !sidebar,
                children: children
            })
        })
    });
};
GuidePageTemplate.propTypes = {
    type: (0,prop_types.oneOf)([
        "guide",
        "tutorial"
    ]),
    wrapperClassName: prop_types.string,
    sidebar: prop_types.bool,
    children: prop_types.node.isRequired
};
/* harmony default export */ var GuidePageTemplate_GuidePageTemplate = (GuidePageTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js



/***/ }),

/***/ 45265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const HeroDividerBottom = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "section-hero__divider-bottom"
    });
/* harmony default export */ __webpack_exports__["Z"] = (HeroDividerBottom);


/***/ }),

/***/ 25672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);




const HeroLead = (param)=>{
    let { className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__lead", className),
        ...props
    });
};
HeroLead.propTypes = {
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroLead);


/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 5370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ BackToTopButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);




const BackToTopButton = ()=>{
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [prevOffset, setPrevOffset] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const toggleScrollDirection = ()=>{
        const { scrollY  } = window;
        const screenHeight = window.screen.height * 2;
        if (scrollY > prevOffset || scrollY < screenHeight) {
            setShowButton(false);
        } else if (scrollY < prevOffset && scrollY > screenHeight) {
            setShowButton(true);
        }
        setPrevOffset(scrollY);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("scroll", toggleScrollDirection);
        return ()=>{
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "back-to-top-button",
            onClick: scrollToTop,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "chevron-up",
                    className: "back-to-top-button--icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "back-to-top-button--text",
                    children: "TOP"
                })
            ]
        })
    });
};


/***/ }),

/***/ 61603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ scrollToHeading; }
/* harmony export */ });
const scrollToHeading = (e)=>{
    e.preventDefault();
    const siblingsFn = (elem)=>{
        const siblings = [];
        let sibling = elem;
        while(sibling.previousSibling){
            sibling = sibling.previousSibling;
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
        }
        sibling = elem;
        while(sibling.nextSibling){
            sibling = sibling.nextSibling;
            if (sibling.nodeType === 1) {
                siblings.push(sibling);
            }
        }
        return siblings;
    };
    const link = e.target;
    const activeClass = "guide-post-container__nav-item-link--active";
    link.classList.add(activeClass);
    siblingsFn(link.parentNode).forEach((sib)=>{
        sib.getElementsByTagName("a")[0].classList.remove(activeClass);
    });
    const id = e.target.hash.replace("#", "");
    const element = document.getElementById(id);
    __webpack_require__.g.window.scrollTo({
        behavior: element ? "smooth" : "auto",
        top: element ? element.offsetTop : 0
    });
};


/***/ }),

/***/ 45312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Apps_Guides; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/createClient/index.js + 17 modules
var createClient = __webpack_require__(68189);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Lead.js
var Lead = __webpack_require__(25672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(78086);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Item.js
var Item = __webpack_require__(71125);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/index.js + 1 modules
var GuidePageTemplate = __webpack_require__(41635);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Sidebar.js
var Sidebar = __webpack_require__(51921);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Main.js
var Main = __webpack_require__(43360);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/GuidePageTemplate/Nav.js
var Nav = __webpack_require__(69738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/Guides/index.js
var Guides = __webpack_require__(61603);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/BackToTopButton/index.js
var BackToTopButton = __webpack_require__(5370);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/index.js + 6 modules
var richTextTypes_default = __webpack_require__(3877);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/richTextTypes/default/utils.js + 1 modules
var utils = __webpack_require__(69482);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/HeroBrand.js
var HeroBrand = __webpack_require__(68103);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Guides/components/SectionHero/brand/Default.js




const SectionHero = (param)=>{
    let { brandCode , heroConfig , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBrand/* default */.Z, {
        brandCode: brandCode,
        config: heroConfig,
        ...props
    });
};
SectionHero.propTypes = {
    brandCode: prop_types.string,
    heroConfig: prop_types.object
};
/* harmony default export */ var Default = (SectionHero);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/DividerBottom.js
var DividerBottom = __webpack_require__(45265);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Guides/components/SectionHero/brand/Omiq.js





const Omiq_SectionHero = (param)=>{
    let { brandCode , heroConfig , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBrand/* default */.Z, {
        brandCode: brandCode,
        config: heroConfig,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerBottom/* default */.Z, {})
        ]
    });
};
Omiq_SectionHero.propTypes = {
    brandCode: prop_types.string,
    heroConfig: prop_types.object,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Omiq = (Omiq_SectionHero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Guides/components/SectionHero/heroConfig.js
const heroConfig = {
    color: {
        sg: "1",
        gn: "white",
        gp: "1",
        om: "white",
        la: "4"
    }
};
/* harmony default export */ var SectionHero_heroConfig = (heroConfig);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Guides/components/SectionHero/SectionHero.js







const SectionHero_SectionHero = (param)=>{
    let { brandCode , children , ...props } = param;
    const HeroComponent = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_OM */.h7:
                return Omiq;
            default:
                return Default;
        }
    };
    const HeroBrand = HeroComponent(brandCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBrand, {
        config: SectionHero_heroConfig,
        brandCode: brandCode,
        ...props,
        children: children
    });
};
SectionHero_SectionHero.propTypes = {
    brandCode: prop_types.string,
    children: prop_types.node.isRequired
};
/* harmony default export */ var components_SectionHero_SectionHero = (SectionHero_SectionHero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Guides/components/SectionHero/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/renderBlockByType.js + 25 modules
var renderBlockByType = __webpack_require__(94061);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/ui/AlertPreviewMode/index.js + 1 modules
var AlertPreviewMode = __webpack_require__(51144);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/index.js + 3 modules
var RecommendedVideos = __webpack_require__(13336);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Guides/Page.js





























const getLeadContent = (brandCode, post)=>brandCode === constants/* BRAND_CODE_LA */.gf ? post.subtitle : post.lead;
const GuidePage = (param)=>{
    let { isPreview , post , pageProps  } = param;
    var ref, ref1;
    const [t] = (0,i18/* useLocale */.bU)("guides");
    const { siteDomain , breadcrumbs =[] , brandCode , pageType =constants/* GUIDE_TYPES.Guide */._E.Guide  } = pageProps;
    const { title , metaDescription ="" , slug , body , toCLink ="" , toCDownloadEbookLink ="" , thumbnail , type =pageType , additionalResources =[] , recommendedVideos =[] , academy =false  } = post;
    const thumbnailUrl = (thumbnail === null || thumbnail === void 0 ? void 0 : (ref = thumbnail.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url) || "";
    const navigation = (0,utils/* sidebarNavigation */.U)(body);
    const totalHeading2 = body.content.reduce((total, current)=>{
        return total + (current.nodeType === "heading-2" ? 1 : 0);
    }, 0);
    const isSidebar = totalHeading2 > 0;
    const brandName = constants/* BRAND_NAMES */.aU[brandCode];
    const heroLead = getLeadContent(pageProps.brandCode, post);
    const ToC = toCLink || toCDownloadEbookLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: "".concat(title, " - ").concat(brandName),
                description: metaDescription,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: "".concat(title, " - ").concat(brandName),
                        description: metaDescription,
                        url: "".concat(siteDomain, "/guides/").concat(slug),
                        image: thumbnailUrl || t("META_IMAGE"),
                        imageSecureUrl: thumbnailUrl || t("META_IMAGE_SECURE"),
                        isImageBaseUrl: !thumbnailUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META_TWITTER_CARD"),
                        site: t("META_TWITTER_SITE"),
                        creator: t("META_TWITTER_CREATOR"),
                        title: "".concat(title, " - ").concat(brandName),
                        description: metaDescription,
                        image: thumbnailUrl || t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: !thumbnailUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: "".concat(siteDomain, "/guides/").concat(slug)
                    })
                ]
            }),
            isPreview ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertPreviewMode/* default */.Z, {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_SectionHero_SectionHero, {
                brandCode: brandCode,
                children: [
                    breadcrumbs && breadcrumbs.length && !academy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                        children: [
                            breadcrumbs.map((breadcrumb)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        Component: Item/* BreadcrumbItemLink */.A,
                                        href: breadcrumb.href,
                                        children: breadcrumb.title
                                    })
                                }, breadcrumb.title)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: title
                            })
                        ]
                    }) : null,
                    academy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroRow */.P, {
                        center: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* HeroCol */.Z, {
                            md: 4,
                            spacing: {
                                mb: 10
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: t("ACADEMY_LINK"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: t("ACADEMY_LOGO"),
                                    isBaseUrl: true
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: title
                    }),
                    heroLead && /*#__PURE__*/ (0,jsx_runtime.jsx)(Lead/* default */.Z, {
                        children: heroLead
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuidePageTemplate/* default */.Z, {
                sidebar: isSidebar,
                type: type,
                children: isSidebar ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sidebar/* default */.Z, {
                            children: [
                                ToC && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* GuidePageTemplateNavItem */.hS, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default.Link */.Z.Link, {
                                        size: "s",
                                        href: ToC,
                                        target: "_blank",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "arrow-to-bottom"
                                            }),
                                            t("DOWNLOAD_AS_EBOOK")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.ZP, {
                                    children: navigation.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* GuidePageTemplateNavItem */.hS, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* GuidePageTemplateNavItemLink */.NI, {
                                                href: "#".concat((0,utils/* generateHeadingId */.A)(item)),
                                                onClick: (e)=>(0,Guides/* scrollToHeading */.U)(e),
                                                children: item
                                            })
                                        }, item);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Main/* default */.Z, {
                            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, richTextTypes_default/* default */.Z)
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Main/* default */.Z, {
                    sidebar: isSidebar,
                    children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, richTextTypes_default/* default */.Z)
                })
            }),
            recommendedVideos.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedVideos/* default */.Z, {
                brandCode: brandCode,
                videos: recommendedVideos
            }),
            additionalResources.map((0,renderBlockByType/* default */.Z)(slug)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackToTopButton/* BackToTopButton */.z, {})
        ]
    });
};
GuidePage.propTypes = {
    isPreview: prop_types.bool,
    post: (0,prop_types.shape)({
        title: prop_types.string.isRequired,
        subtitle: prop_types.string,
        metaDescription: prop_types.string,
        slug: prop_types.string.isRequired,
        lead: prop_types.string,
        body: prop_types.object,
        toCLink: prop_types.string,
        toCDownloadEbookLink: prop_types.string
    }),
    pageProps: (0,prop_types.shape)({
        resources: prop_types.any,
        siteDomain: prop_types.string.isRequired,
        brandCode: prop_types.string,
        breadcrumbs: (0,prop_types.arrayOf)((0,prop_types.shape)({
            title: prop_types.string.isRequired,
            href: prop_types.string.isRequired
        }))
    })
};
/* harmony default export */ var Page = (GuidePage);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/locales/index.js
var locales = __webpack_require__(5235);
var locales_default = /*#__PURE__*/__webpack_require__.n(locales);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/checkPreviewMode.js + 1 modules
var checkPreviewMode = __webpack_require__(17335);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Guides/index.js











const contentfulGuidesFactory = (param)=>{
    let { Layout , contentfulProps , pageProps  } = param;
    const ContentfulGuidesPage = (param)=>{
        let { isPreview , post  } = param;
        const { brandCode , resources =null  } = pageProps;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(i18/* LocaleProvider */.Iw, {
                resources: resources || (locales_default())[brandCode],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    isPreview: isPreview,
                    post: post,
                    pageProps: pageProps
                })
            })
        });
    };
    ContentfulGuidesPage.getInitialProps = async (param)=>{
        let { req , query  } = param;
        const { slug  } = query;
        const isPreview = (0,checkPreviewMode/* default */.Z)(req);
        const client = (0,createClient/* default */.Z)(contentfulProps, isPreview);
        const item = await client.getEntries({
            include: 2,
            content_type: "pageGuide",
            "fields.slug": slug
        });
        if (item.total === 0) {
            return {
                post: null
            };
        }
        return {
            isPreview,
            post: item.items[0].fields
        };
    };
    ContentfulGuidesPage.propTypes = {
        ...Page.propTypes
    };
    ContentfulGuidesPage.postConditions = [
        [
            (param)=>{
                let { post  } = param;
                return post;
            },
            (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
        ]
    ];
    return (0,pipe/* default */.Z)(ContentfulGuidesPage, WithConditions/* default */.ZP);
};
/* harmony default export */ var Apps_Guides = (contentfulGuidesFactory);


/***/ }),

/***/ 13336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_RecommendedVideos_RecommendedVideos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/constants/index.js
var constants = __webpack_require__(34491);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/CardBlock/index.js + 5 modules
var CardBlock = __webpack_require__(62039);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/contentful/utils/getContentProps.js
var getContentProps = __webpack_require__(76638);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/brand/Default.js







const RecommendedVideos = (param)=>{
    let { videos  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: "white",
        isBorderNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                children: "Recommended Resources"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockRow */.nC, {
                children: videos.map((video)=>{
                    const contentProps = (0,getContentProps/* default */.Z)(video.sys.contentType.sys.id);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockCol */.YT, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* default */.ZP, {
                            LinkComponent: Link/* default */.Z,
                            cardType: contentProps.typePlaceholder,
                            titleText: video.fields.title,
                            imgSrc: video.fields.thumbnail.fields.file.url,
                            descriptionText: video.fields.metaDescription,
                            href: "".concat(contentProps.alias, "/").concat(video.fields.slug),
                            linkButtonText: contentProps.linkPlaceholder
                        })
                    }, video.sys_id);
                })
            })
        ]
    });
};
RecommendedVideos.propTypes = {
    videos: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            body: prop_types.object,
            lead: prop_types.string,
            metaDescription: prop_types.string,
            slug: prop_types.string,
            thumbnail: (0,prop_types.shape)({
                fields: (0,prop_types.shape)({
                    description: prop_types.string,
                    file: (0,prop_types.shape)({
                        contentType: prop_types.string,
                        details: (0,prop_types.shape)({
                            image: (0,prop_types.shape)({
                                height: prop_types.number,
                                width: prop_types.number
                            }),
                            size: prop_types.number
                        }),
                        fileName: prop_types.string,
                        url: prop_types.string
                    }),
                    title: prop_types.string
                }),
                metadata: (0,prop_types.shape)({
                    tags: prop_types.array
                }),
                sys: prop_types.object
            }),
            title: prop_types.string,
            toClick: prop_types.string
        }),
        metadata: (0,prop_types.shape)({
            tags: prop_types.array
        }),
        sys: prop_types.object
    }))
};
/* harmony default export */ var Default = (RecommendedVideos);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/brand/LabArchives.js







const LabArchives_RecommendedVideos = (param)=>{
    let { videos  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        bgColor: "white",
        isBorderNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Title */.Z.Title, {
                children: "Recommended Resources"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockRow */.nC, {
                children: videos.map((video)=>{
                    const contentProps = (0,getContentProps/* default */.Z)(video.sys.contentType.sys.id);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* CardBlockCol */.YT, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBlock/* default */.ZP, {
                            LinkComponent: Link/* default */.Z,
                            cardType: contentProps.typePlaceholder,
                            titleText: video.fields.title,
                            imgSrc: video.fields.thumbnail.fields.file.url,
                            descriptionText: video.fields.metaDescription,
                            href: "".concat(contentProps.alias, "/").concat(video.fields.slug),
                            linkButtonText: contentProps.linkPlaceholder
                        })
                    }, video.sys_id);
                })
            })
        ]
    });
};
LabArchives_RecommendedVideos.propTypes = {
    videos: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            body: prop_types.object,
            lead: prop_types.string,
            metaDescription: prop_types.string,
            slug: prop_types.string,
            thumbnail: (0,prop_types.shape)({
                fields: (0,prop_types.shape)({
                    description: prop_types.string,
                    file: (0,prop_types.shape)({
                        contentType: prop_types.string,
                        details: (0,prop_types.shape)({
                            image: (0,prop_types.shape)({
                                height: prop_types.number,
                                width: prop_types.number
                            }),
                            size: prop_types.number
                        }),
                        fileName: prop_types.string,
                        url: prop_types.string
                    }),
                    title: prop_types.string
                }),
                metadata: (0,prop_types.shape)({
                    tags: prop_types.array
                }),
                sys: prop_types.object
            }),
            title: prop_types.string,
            toClick: prop_types.string
        }),
        metadata: (0,prop_types.shape)({
            tags: prop_types.array
        }),
        sys: prop_types.object
    }))
};
/* harmony default export */ var LabArchives = (LabArchives_RecommendedVideos);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/RecommendedVideos.js






const RecommendedVideos_RecommendedVideos = (param)=>{
    let { brandCode , videos  } = param;
    const RecommendedVideosComponent = (brand)=>{
        switch(brand.toLowerCase()){
            case constants/* BRAND_CODE_LA */.gf:
                return LabArchives;
            default:
                return Default;
        }
    };
    const RecommendedVideosBrand = RecommendedVideosComponent(brandCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedVideosBrand, {
        videos: videos
    });
};
RecommendedVideos_RecommendedVideos.propTypes = {
    brandCode: prop_types.string,
    videos: (0,prop_types.arrayOf)((0,prop_types.shape)({
        fields: (0,prop_types.shape)({
            body: prop_types.object,
            lead: prop_types.string,
            metaDescription: prop_types.string,
            slug: prop_types.string,
            thumbnail: (0,prop_types.shape)({
                fields: (0,prop_types.shape)({
                    description: prop_types.string,
                    file: (0,prop_types.shape)({
                        contentType: prop_types.string,
                        details: (0,prop_types.shape)({
                            image: (0,prop_types.shape)({
                                height: prop_types.number,
                                width: prop_types.number
                            }),
                            size: prop_types.number
                        }),
                        fileName: prop_types.string,
                        url: prop_types.string
                    }),
                    title: prop_types.string
                }),
                metadata: (0,prop_types.shape)({
                    tags: prop_types.array
                }),
                sys: prop_types.object
            }),
            title: prop_types.string,
            toClick: prop_types.string
        }),
        metadata: (0,prop_types.shape)({
            tags: prop_types.array
        }),
        sys: prop_types.object
    }))
};
/* harmony default export */ var components_RecommendedVideos_RecommendedVideos = (RecommendedVideos_RecommendedVideos);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/contentful/Apps/Series/components/RecommendedVideos/index.js



/***/ }),

/***/ 34491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ub": function() { return /* binding */ RELEASE_NOTES_PER_PAGE; },
/* harmony export */   "_E": function() { return /* binding */ GUIDE_TYPES; },
/* harmony export */   "aU": function() { return /* binding */ BRAND_NAMES; },
/* harmony export */   "gf": function() { return /* binding */ BRAND_CODE_LA; },
/* harmony export */   "h7": function() { return /* binding */ BRAND_CODE_OM; },
/* harmony export */   "lc": function() { return /* binding */ PUBLISHED; },
/* harmony export */   "yB": function() { return /* binding */ BRAND_CODE_GP; }
/* harmony export */ });
/* unused harmony exports BLOGS_PER_PAGE, BRAND_CODE_SG, BRAND_CODE_GN */
const RELEASE_NOTES_PER_PAGE = 20;
const BLOGS_PER_PAGE = 12;
const BRAND_CODE_GP = "gp";
const BRAND_CODE_SG = "sg";
const BRAND_CODE_GN = "gn";
const BRAND_CODE_OM = "om";
const BRAND_CODE_LA = "la";
const PUBLISHED = "Live";
const GUIDE_TYPES = {
    Guide: "guide",
    Tutorial: "tutorial"
};
const BRAND_NAMES = {
    om: "OMIQ",
    sg: "Snapgene",
    gp: "Graphpad",
    gn: "Geneious",
    la: "LabArchives"
};


/***/ }),

/***/ 68103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69591);




const HeroBrand = (param)=>{
    let { brandCode ="sg" , config , children , ...props } = param;
    const { color  } = config;
    const brandColor = (brand)=>color[brand];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        color: brandColor(brandCode),
        ...props,
        children: children
    });
};
HeroBrand.propTypes = {
    brandCode: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "sg",
        "gp",
        "gn",
        "om",
        "la"
    ]),
    config: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
        color: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.shape)({
            gn: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            sg: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            gp: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            om: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
            la: prop_types__WEBPACK_IMPORTED_MODULE_3__.string
        })
    }),
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroBrand);


/***/ }),

/***/ 73972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



const Html = (param)=>/*#__PURE__*/ {
    let { Tag ="div" , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        dangerouslySetInnerHTML: {
            __html: children
        },
        ...props
    });
};
Html.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_2__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_2__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_2__.element
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_2__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (Html);


/***/ })

}]);